import React from 'react';

import { Header } from '@vimeo/bokeh';

import { PlanHeader, PlanTitle, PlanSubTitle } from './styles';
import { PLANS_DISPLAY_NAMES } from '../../../utils/constants';
import { defaultTemplateProps, PlanData } from '../../../utils/interface';
import { getPlanSubHeading, getBandwidthSubHeader } from '../../../utils/utils';

interface Props {
  planData: PlanData;
  modalConfig?: defaultTemplateProps;
  hideSubheading: boolean;
}

const PlanCardHeader = ({ planData, modalConfig, hideSubheading }: Props) => {
  const planSubHeading = getPlanSubHeading(modalConfig, planData);
  const bandwidthSubHeader = getBandwidthSubHeader(planData);

  return (
    <PlanHeader
      style={{
        height: hideSubheading ? '' : '4rem',
      }}
    >
      <PlanTitle>{planData.name}</PlanTitle>
      <Header size="sm" fontWeight={400}>
        {bandwidthSubHeader}
      </Header>
      {(!hideSubheading &&
        !planData.metadata.isBandwidthProduct &&
        planSubHeading &&
        planSubHeading.length) > 0 ? (
        <PlanSubTitle>{planSubHeading}</PlanSubTitle>
      ) : null}
    </PlanHeader>
  );
};

export default PlanCardHeader;
